function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Parse medical report text into structured sections
 * Identifies predefined medical report headings and their associated content
 *
 * Valid headings: Indication, Comparison, Findings, Impression, Recommendation,
 * Clinical History, Technique, History
 *
 * @param reportText - The raw report text to parse
 * @returns Array of sections with heading and content
 *
 * Features:
 * - Recognizes headings followed by colon (case-insensitive)
 * - Supports content on the same line as heading
 * - Reduces excessive consecutive newlines (4→3, 3→2, 2→1)
 * - Preserves preamble content before first heading
 *
 * @example
 * const text = "CT CHEST\n\nClinical History:\nPatient symptoms\n\nFindings: Test results";
 * const sections = parseReportText(text);
 * // Returns:
 * // [
 * //   { heading: "", content: "CT CHEST" },
 * //   { heading: "Clinical History", content: "Patient symptoms" },
 * //   { heading: "Findings", content: "Test results" }
 * // ]
 */
// Valid report section headings
var VALID_HEADINGS = ["indication", "comparison", "findings", "impression", "recommendation", "clinical history", "technique", "history", "category", "management", "exam"];
export var parseReportText = function parseReportText(reportText) {
  if (!reportText || typeof reportText !== "string") {
    return [];
  }
  var lines = reportText.split("\n");
  var sections = [];
  var currentSection = null;

  // First, collect lines before any heading (like "CT CHEST")
  var preambleLines = [];
  var _iterator = _createForOfIteratorHelper(lines),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var line = _step.value;
      var trimmedLine = line.trim();

      // Check if this line is a heading
      // A heading must have a colon and match one of the predefined headings
      var colonIndex = trimmedLine.indexOf(":");
      var isLikelyHeading = false;
      if (colonIndex !== -1) {
        var potentialHeading = trimmedLine.slice(0, colonIndex).trim().toLowerCase();
        isLikelyHeading = VALID_HEADINGS.includes(potentialHeading);
      }
      if (isLikelyHeading) {
        // Save the previous section if it exists
        if (currentSection) {
          // Clean up content: trim and reduce newlines by one (4→3, 3→2, 2→1)
          currentSection.content = currentSection.content.trim().replace(/\n{2,}/g, function (match) {
            return match.slice(1);
          });
          sections.push(currentSection);
        }

        // Extract heading (text before ":") and any content on the same line (text after ":")
        var heading = trimmedLine.slice(0, colonIndex).trim();
        var contentOnSameLine = trimmedLine.slice(colonIndex + 1).trim();

        // Start a new section
        currentSection = {
          heading: heading || "",
          // Allow empty heading
          content: contentOnSameLine ? contentOnSameLine + "\n" : ""
        };
      } else if (currentSection) {
        // Add content to the current section
        currentSection.content += line + "\n";
      } else if (trimmedLine) {
        // Lines before any heading (like "CT CHEST")
        preambleLines.push(line);
      }
    }

    // Save the last section
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (currentSection) {
    // Clean up content: trim and reduce newlines by one (4→3, 3→2, 2→1)
    currentSection.content = currentSection.content.trim().replace(/\n{2,}/g, function (match) {
      return match.slice(1);
    });
    sections.push(currentSection);
  }

  // If there's preamble content (like "CT CHEST"), add it as the first section
  if (preambleLines.length > 0) {
    var preambleContent = preambleLines.join("\n").trim().replace(/\n{2,}/g, function (match) {
      return match.slice(1);
    });
    if (preambleContent) {
      sections.unshift({
        heading: "",
        content: preambleContent
      });
    }
  }
  return sections;
};